import { Button } from "@repo/ui/components/button"
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@repo/ui/components/command"
import { Search } from "lucide-react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"

import { navGroups } from "@/lib/nav"

/** Jump to any page from the sidebar with Ctrl/Cmd+K. */
export function CommandPalette() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key.toLowerCase() === "k" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault()
        setOpen((current) => !current)
      }
    }

    document.addEventListener("keydown", onKeyDown)

    return () => document.removeEventListener("keydown", onKeyDown)
  }, [])

  function go(to: string) {
    setOpen(false)
    void navigate(to)
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="hidden w-56 justify-start gap-2 font-normal text-muted-foreground sm:flex"
        onClick={() => setOpen(true)}
      >
        <Search />
        Search
        <kbd className="ml-auto rounded border bg-muted px-1.5 text-[10px] font-medium">
          Ctrl K
        </kbd>
      </Button>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label="Search"
        className="sm:hidden"
        onClick={() => setOpen(true)}
      >
        <Search />
      </Button>

      <CommandDialog
        open={open}
        onOpenChange={setOpen}
        title="Search"
        description="Jump to a page"
      >
        <CommandInput placeholder="Go to…" />
        <CommandList>
          <CommandEmpty>No pages found.</CommandEmpty>
          {navGroups.map((group) => (
            <CommandGroup key={group.title} heading={group.title}>
              {group.items.map((item) => (
                <CommandItem
                  key={item.to}
                  value={`${group.title} ${item.title}`}
                  onSelect={() => go(item.to)}
                >
                  <item.icon />
                  <span>{item.title}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          ))}
        </CommandList>
      </CommandDialog>
    </>
  )
}
